import { MESSAGES } from "../../config/messages";
import { TMatter } from "../../models/matter-model";
import { TMatterRetriever } from "../../services/matter-retriever";
import { MatterInfoPresentational, MatterInfoPresentationalProps } from "../MatterInfo/MatterInfoPresentational";
import { MessageContainer, Severity } from "../Message/MessageContainer";
import { SearchContainer } from "../Search/SearchContainer";
import { Spinner } from "../Spinner/Spinner";

export interface Props {
  isLoading: boolean;
  isMatterIdFound: boolean;
  isMatterDataLoaded: boolean;
  isAssigningToMatter: boolean;
  selectedMatter: TMatter | null;
  isSavingToMatter: boolean;
  matterRetriever: TMatterRetriever;

  saveToMatter?: () => void;
  assignToMatter?: MatterInfoPresentationalProps["assignToMatter"];
}

export const TaskpanePresentational = (props: Props) => {
  if (props.isLoading) {
    return <Spinner message={MESSAGES.LOADING_MATTER_DATA} />;
  }

  if (props.isMatterIdFound && !props.isMatterDataLoaded) {
    /* Found invalid MatterId */
    return (
      <MessageContainer
        className="m-4"
        title={MESSAGES.MATTER_DATA_UNAVAILABLE}
        content={MESSAGES.MATTER_NOT_FOUND}
        severity={Severity.Information}
      />
    );
  }

  return (
    <div className="flex flex-col flex-1 items-stretch max-h-full min-h-0 bg-neutral-50">
      <div className="flex flex-col justify-stretch bg-white min-h-0 max-h-full">
        {props.selectedMatter ? (
          /* Matter info and spinner */
          <div className="flex flex-col flex-shrink-0 w-full bg-white">
            <div className="flex flex-col min-h-0">
              <MatterInfoPresentational
                matter={props.selectedMatter}
                saveToMatter={props.saveToMatter}
                isSelected={true}
              />
            </div>
            {props.isSavingToMatter && <Spinner message={MESSAGES.SAVING_TO_MATTER} />}
            {props.isAssigningToMatter && <Spinner message={MESSAGES.ASSIGNING_TO_MATTER} />}
          </div>
        ) : (
          /* Recent matters and search box */
          <div className="flex flex-col max-h-full min-h-0">
            <SearchContainer assignToMatter={props.assignToMatter} matterRetriever={props.matterRetriever} />
          </div>
        )}
      </div>
    </div>
  );
};
